import { defaultFeatureFlags } from "../../config/defaultFeatureFlags";
import type { FeatureFlagKey, PartialFeatureFlags } from "./featureFlags.type";
import { deepFreeze } from "./deepFreeze";

export const createFeatureFlags = (flags: PartialFeatureFlags) => {
  const featureFlags = structuredClone(defaultFeatureFlags);
  for (const key in flags) {
    if (key in featureFlags) {
      featureFlags[key as FeatureFlagKey] = {
        ...featureFlags[key as FeatureFlagKey],
        ...flags[key as FeatureFlagKey],
      };
    }
  }
  return deepFreeze(featureFlags);
};
